import { useEffect, useRef, useState } from "react";
import ContactUsForm from "./ContactUsForm";

const ContactModal = () => {
    const [contactTitle, setContactTitle] = useState('Contact Us');
    const [isTrialContact, setIsTrialContact] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formRef = useRef();

    useEffect(() => {
        const contactModalElement = document.getElementById('contactUsModal');
        if (contactModalElement) {
            contactModalElement.addEventListener('show.bs.modal', (event) => {
                const button = event.relatedTarget;
                const contactType = button?.getAttribute('data-bs-type') || '';

                if (contactType === 'support') {
                    setContactTitle('Support');
                    setIsTrialContact(false);
                } else if (contactType === 'trial-contact') {
                    setContactTitle('Contact Us');
                    setIsTrialContact(true);
                } else {
                    setContactTitle('Contact Us');
                    setIsTrialContact(false);
                }
            });
        }

        return () => {
            if (contactModalElement) {
                contactModalElement.removeEventListener('show.bs.modal', null); // Clean up event listener
            }
        };
    }, []);

    const handleSend = async () => {
        if (!formRef.current || typeof formRef.current.submitForm !== 'function') return;
        
        setIsSubmitting(true);
        
        try {
            const success = await formRef.current.submitForm();
            
            if (success) {
                // Close the modal after successful submission
                const modal = window.bootstrap?.Modal.getOrCreateInstance(document.getElementById('contactUsModal'));
                modal?.hide();
                
                // Clean up any modal backdrop that might remain
                setTimeout(() => {
                    const backdrops = document.querySelectorAll('.modal-backdrop');
                    backdrops.forEach(backdrop => backdrop.remove());
                    document.body.classList.remove('modal-open');
                    document.body.style.overflow = '';
                    document.body.style.paddingRight = '';
                }, 300);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <div className="modal fade" id="contactUsModal" tabIndex="-1" aria-labelledby="contactUsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="contactUsModalLabel">{contactTitle}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <ContactUsForm contactType={contactTitle} showRequestDemo={contactTitle !== 'Support'} isTrialContact={isTrialContact} ref={formRef} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={isSubmitting}>Close</button>
                        <button type="button" className="btn btn-primary" onClick={handleSend} disabled={isSubmitting}>
                            {isSubmitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                            {isSubmitting ? 'Sending...' : 'Send'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactModal;